/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import '../../message/flag_config';
import '../../message/status';
import '../../../../../flagmetricsexp/message/flag_evaluation_details';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "flags": {
                "nested": {
                  "v2": {
                    "nested": {
                      "message": {
                        "nested": {
                          "BooleanFlag": {
                            "fields": {
                              "flagKey": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.message.FlagConfig",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "StringFlag": {
                            "fields": {
                              "flagKey": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.message.FlagConfig",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "IntFlag": {
                            "fields": {
                              "flagKey": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.message.FlagConfig",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "DoubleFlag": {
                            "fields": {
                              "flagKey": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.message.FlagConfig",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "JsonFlag": {
                            "fields": {
                              "flagKey": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.message.FlagConfig",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "FlagGroups": {
                            "fields": {
                              "booleanFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.BooleanFlag",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "stringFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.StringFlag",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "intFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.IntFlag",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "doubleFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.DoubleFlag",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "jsonFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.JsonFlag",
                                "id": 5,
                                "rule": "repeated"
                              }
                            }
                          },
                          "BooleanFlagResponse": {
                            "fields": {
                              "status": {
                                "type": ".squareup.feature.relay.flags.message.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagKey": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "value": {
                                "type": "bool",
                                "id": 3,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagConfigResponse",
                                "id": 4,
                                "rule": "optional"
                              },
                              "evaluationMetadata": {
                                "type": ".squareup.feature.relay.flags.v2.message.EvaluationMetadata",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          },
                          "StringFlagResponse": {
                            "fields": {
                              "status": {
                                "type": ".squareup.feature.relay.flags.message.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagKey": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "value": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagConfigResponse",
                                "id": 4,
                                "rule": "optional"
                              },
                              "evaluationMetadata": {
                                "type": ".squareup.feature.relay.flags.v2.message.EvaluationMetadata",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          },
                          "IntFlagResponse": {
                            "fields": {
                              "status": {
                                "type": ".squareup.feature.relay.flags.message.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagKey": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "value": {
                                "type": "int32",
                                "id": 3,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagConfigResponse",
                                "id": 4,
                                "rule": "optional"
                              },
                              "evaluationMetadata": {
                                "type": ".squareup.feature.relay.flags.v2.message.EvaluationMetadata",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          },
                          "DoubleFlagResponse": {
                            "fields": {
                              "status": {
                                "type": ".squareup.feature.relay.flags.message.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagKey": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "value": {
                                "type": "double",
                                "id": 3,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagConfigResponse",
                                "id": 4,
                                "rule": "optional"
                              },
                              "evaluationMetadata": {
                                "type": ".squareup.feature.relay.flags.v2.message.EvaluationMetadata",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          },
                          "JsonFlagResponse": {
                            "fields": {
                              "status": {
                                "type": ".squareup.feature.relay.flags.message.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagKey": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "value": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "flagConfig": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagConfigResponse",
                                "id": 4,
                                "rule": "optional"
                              },
                              "evaluationMetadata": {
                                "type": ".squareup.feature.relay.flags.v2.message.EvaluationMetadata",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          },
                          "FlagConfigResponse": {
                            "fields": {
                              "flagValueExpirationHours": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagValueCooldownHours": {
                                "type": "int32",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "EvaluationMetadata": {
                            "fields": {
                              "evaluationReason": {
                                "type": ".squareup.flagmetricsexp.message.EvaluationReason",
                                "id": 1,
                                "rule": "optional"
                              },
                              "prerequisites": {
                                "type": ".squareup.flagmetricsexp.message.Prerequisite",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          },
                          "FlagGroupsResponse": {
                            "fields": {
                              "booleanFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.BooleanFlagResponse",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "stringFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.StringFlagResponse",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "intFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.IntFlagResponse",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "doubleFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.DoubleFlagResponse",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "jsonFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.JsonFlagResponse",
                                "id": 5,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.BooleanFlag && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.StringFlag && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.IntFlag && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.DoubleFlag && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.JsonFlag && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.FlagGroups && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.BooleanFlagResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.StringFlagResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.IntFlagResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.DoubleFlagResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.JsonFlagResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.FlagConfigResponse && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.EvaluationMetadata && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.FlagGroupsResponse) {
	$root.addJSON(jsonData);
}

/**
 * Requests
 *
 * SOURCE BooleanFlag @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 15:1
 */
export const BooleanFlag = $root.lookupType('squareup.feature.relay.flags.v2.message.BooleanFlag');
fixType(BooleanFlag, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(BooleanFlag);
/**
 * SOURCE StringFlag @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 24:1
 */
export const StringFlag = $root.lookupType('squareup.feature.relay.flags.v2.message.StringFlag');
fixType(StringFlag, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(StringFlag);
/**
 * SOURCE IntFlag @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 33:1
 */
export const IntFlag = $root.lookupType('squareup.feature.relay.flags.v2.message.IntFlag');
fixType(IntFlag, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(IntFlag);
/**
 * SOURCE DoubleFlag @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 42:1
 */
export const DoubleFlag = $root.lookupType('squareup.feature.relay.flags.v2.message.DoubleFlag');
fixType(DoubleFlag, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(DoubleFlag);
/**
 * SOURCE JsonFlag @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 51:1
 */
export const JsonFlag = $root.lookupType('squareup.feature.relay.flags.v2.message.JsonFlag');
fixType(JsonFlag, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(JsonFlag);
/**
 * SOURCE FlagGroups @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 60:1
 */
export const FlagGroups = $root.lookupType('squareup.feature.relay.flags.v2.message.FlagGroups');
fixType(FlagGroups);
Builder.createAndAttachToType(FlagGroups);
/**
 * Responses
 *
 * SOURCE BooleanFlagResponse @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 70:1
 */
export const BooleanFlagResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.BooleanFlagResponse');
fixType(BooleanFlagResponse, {
  flagKey: { notEmpty: true },
});
Builder.createAndAttachToType(BooleanFlagResponse);
/**
 * SOURCE StringFlagResponse @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 78:1
 */
export const StringFlagResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.StringFlagResponse');
fixType(StringFlagResponse, {
  flagKey: { notEmpty: true },
});
Builder.createAndAttachToType(StringFlagResponse);
/**
 * SOURCE IntFlagResponse @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 86:1
 */
export const IntFlagResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.IntFlagResponse');
fixType(IntFlagResponse, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(IntFlagResponse);
/**
 * SOURCE DoubleFlagResponse @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 94:1
 */
export const DoubleFlagResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.DoubleFlagResponse');
fixType(DoubleFlagResponse, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(DoubleFlagResponse);
/**
 * SOURCE JsonFlagResponse @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 102:1
 */
export const JsonFlagResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.JsonFlagResponse');
fixType(JsonFlagResponse, {
  flagKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(JsonFlagResponse);
/**
 * SOURCE FlagConfigResponse @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 110:1
 */
export const FlagConfigResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.FlagConfigResponse');
fixType(FlagConfigResponse);
Builder.createAndAttachToType(FlagConfigResponse);
/**
 * SOURCE EvaluationMetadata @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 118:1
 */
export const EvaluationMetadata = $root.lookupType('squareup.feature.relay.flags.v2.message.EvaluationMetadata');
fixType(EvaluationMetadata);
Builder.createAndAttachToType(EvaluationMetadata);
/**
 * SOURCE FlagGroupsResponse @ squareup/feature/relay/flags/v2/message/flag_groups.proto at 123:1
 */
export const FlagGroupsResponse = $root.lookupType('squareup.feature.relay.flags.v2.message.FlagGroupsResponse');
fixType(FlagGroupsResponse);
Builder.createAndAttachToType(FlagGroupsResponse);
